export const Status = {
  0: {titulo: 'Rascunho', class: 'light', color: '#FFFFFF'},
  1: {titulo: 'Ativo', class: 'success', color: '#FFFFFF'},
  99: {titulo: 'Removido', class: 'danger'}
}



// WEBPACK FOOTER //
// ./src/domain/eventos/helpers/Status.js